import React from "react";
import behance from "../../assets/images/behance.png";
import star from "../../assets/images/coffee.png";

const HeaderPage = () => {
  return (
    <div>
      <section className=" bg-white  p-10 mt-1">
        <div className="py-8 px-4 mx-auto max-w-screen-xl text-center lg:py-16 lg:px-12">
          <h1 class="mb-10 text-4xl font-extrabold text-gray-900  dark:text-white md:text-6xl  lg:text-7xl">
            <span class="text-transparent bg-clip-text bg-gradient-to-r to-pink-600 from-sky-400 font-Kalam">
              SHYAM DEVAKUMARAN
            </span>{" "}
          </h1>
          <p class="mb-10 text-4xl font-medium text-black  sm:px-16 xl:px-48 dark:text-gray-400 font-Pacifico">
            Building Digital&nbsp;
            <span class="text-transparent bg-clip-text bg-gradient-to-r to-purple-900 from-red-400 ">
              Products{" "}
            </span>
            and &nbsp;
            <span class="text-transparent bg-clip-text bg-gradient-to-r to-purple-900 from-red-400 ">
              Brands!
            </span>
          </p>
          <a
            class="inline-flex justify-center cursor-default items-center 
                     text-center bg-blue-600 hover:bg-blue-700 border border-transparent
                      text-sm lg:text-base text-white font-medium rounded-md focus:outline-none 
                      focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 focus:ring-offset-white 
                      transition py-3 px-4 dark:focus:ring-offset-gray-800"
            href="#"
          >
            Hire me on ?
            <svg
              className="ml-2 -mr-1 w-5 h-5"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                clipRule="evenodd"
              ></path>
            </svg>
          </a>{" "}
          &nbsp;
          <a
            href="https://www.behance.net/shyamdevakum"
            target="_blank"
            class="inline-flex justify-center  items-center 
                     text-center bg-black hover:bg-gray-900 border border-transparent
                      text-sm lg:text-base text-white font-medium rounded-md focus:outline-none 
                      focus:ring-2 focus:ring-black focus:ring-offset-2 focus:ring-offset-white cursor-pointer
                      transition py-3 px-4 dark:focus:ring-offset-gray-800
                            "
          >
            Behance
          </a>
          <br />
          <br />
          <a href="https://bmc.link/shyam08" target="_blank">
          <div
            className=" inline-flex justify-center  items-center 
                     text-center bg-black hover:bg-white border border-black hover:text-black
                      text-sm lg:text-base text-white font-medium rounded-md focus:outline-none 
                      focus:ring-2 focus:ring-black-600 focus:ring-offset-2 focus:ring-offset-white 
                      transition py-2 px-2 dark:focus:ring-offset-gray-800 cursor-pointer"
          >
            <img src={star} className="h-6 w-6" alt="star" />
            &nbsp;
            <div className="text-2xl"> Buy me a Coffee</div>
          </div>
          </a>
        </div>
      </section>
    </div>
  );
};

export default HeaderPage;
